import type { ReactNode } from 'react';

export const symbol_stylus_pencil: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M289-326q-16 0-25-13t-3-28l177-453q4-9 12-14.5t18-5.5h24q10 0 18 5.5t12 14.5l177 453q6 15-3 28t-25 13H289Zm43-60h296L480-760 332-386Zm0 0h296-296ZM203-120q-16 0-24.5-12.5T175-160l6-17q8-22 27-35.5t42-13.5h460q23 0 42 13.5t27 35.5l6 17q5 15-3.5 27.5T757-120H203Z"
		/>
	</svg>
);
